<template>
  <section class="splash-page splash-page--desktop splash-page--desktop-ge" v-show="!isLoading"
    @click="backgroundClick">
    <div class="splash-page-modal-top-nav-close splash-page__nav-close" @click.stop="closeClick">
      <span class="icon-close"></span>
    </div>

    <div :class="[
      'splash-page-modal-graphic-editor-img',
      !isUgcApplied ? 'splash-page-modal-graphic-editor-not-ugc' : ''
      ]" ref="partsCustomize">
      <div class="skip-cta splash-page__skip">
        <button class="splash-page__label" @click="onSkip">{{ getTranslation('skipToGetStarted') }}</button>
      </div>

      <div :class="[
        'splash-page__ge-zoom',
        'splash-page__header-tools',
        regionIsApac ? 'splash-page__header-tools--apac' : ''
      ]" v-show="verifyModuleVisibility('header') && isUgcApplied">
        <img class="splash-page__arrow splash-page__arrow--tools"
          :src="`${customsAssets}/svg/customizer/icon-scroll.svg`">
      </div>

      <div :class="[
        'splash-page__ge-customize',
        'splash-page__header-tools',
        regionIsApac ? 'splash-page__header-tools--apac' : ''
      ]" v-show="verifyModuleVisibility('header')">
        <img class="splash-page__arrow splash-page__arrow--tools"
          :src="`${customsAssets}/svg/customizer/icon-hand-touch.svg`">
        <label class="splash-page__label">{{ getTranslation('tapGraphicCustomize') }}</label>
      </div>


      <div class="splash-page__ge-drag-rep-img" v-show="verifyModuleVisibility('tabs') && isUgcApplied">
        <img class="splash-page-desktop__arrow" :src="`${customsAssets}/svg/customizer/icon-hand-direction.svg`">
        <label class="splash-page__label">{{ getTranslation('dragRepositionImage') }}</label>
      </div>

      <label class="splash-page__ge-manual-zoom-control" v-show="verifyModuleVisibility('manual_zoom') && configuration.apparel_settings?.enable_graphic_zoom && isUgcApplied">
        <img class="splash-page-desktop__arrow" :src="`${customsAssets}/svg/customizer/bottom-to-up-circle-arrow.svg`">
        <label class="splash-page__label">{{ getTranslation('manualZoomControl') }}</label>
        <div class="splash-page_ge-manual-zoom-control tool"><label class="control-left">-</label><div class="input-container"><input disabled class="custom-input" value="2" min="1" max="5" type="range"/></div><label class="control-right">+</label></div>
        <img class="splash-page__ge-manual-zoom-control right-to-left-circle-arrow" :src="`${customsAssets}/svg/customizer/right-to-left-circle-arrow.svg`">
      </label>

    </div>

    <div class="splash-page__ge-done">
      <label class="splash-page_ge-done-button">
        {{ translations.apparel.graphicZoomOut }}
      </label>
      <img class="splash-page-desktop__arrow"
        :src="`${customsAssets}/images/customizer/add-your-own-arrow-step2.png`">
      <label class="splash-page__label">{{ getTranslation('tapDone') }}</label>
    </div>

  </section>
</template>

<script>
export default {
  name: "GraphicEditorDesktop",
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    isTouchStarted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      styledElements: {},
      initialTimestamp: null,
    };
  },
  computed: {
    activeComponent() {
      return this.$store.state.standardNavigation.activeComponent;
    },
    translations() {
      return this.$store.state.translations.data;
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    regionIsApac() {
      return this.$store.getters["utils/regionIsApac"];
    },
    isUgcApplied() {
      return this.$recipe.checkApparelUGC();
    }
  },
  watch: {
    isLoading(newValue) {
      if (!newValue) {
        this.showComponentsHelpers();
      }
    }
  },
  methods: {
    backgroundClick(event) {
      if (event.target.classList.contains("splash-page-modal-graphic-editor-img")) {
        this.closeClick();
      }
    },
    getTranslation(key) {
      return this.translations.simplifiedSplashPage.desktop[key];
    },
    closeClick() {
      if (!this.regionIsApac) {
        document.getElementsByClassName("v--modal-overlay")[0].style.position =
          "fixed";
      }
      this.toggleSplashPageOpenClass('remove');
      this.isLoading = false;
      this.$modal.hide('splashPageModal');
      this.$store.commit('utils/SET_IS_SPLASH_MODAL_OPEN', false);
    },
    toggleSplashPageOpenClass(method = 'add') {
      const selectors = ["graphics-controller__zoom-in", "graphics-controller__detailed-editor", "graphics-controller__detailed-editor-container"];
      for (let selector of selectors) {
        try {
          if (selector === "swatches-view-header" && !this.verifyModuleVisibility('buy_panel')) {
            document.getElementsByClassName(selector)[0].classList[method]('splash-desktop-modal-open-alt-bottom');
          } else {
            document.getElementsByClassName(selector)[0].classList[method]('splash-desktop-modal-open');
          }
        } catch (err) {
          console.error(`not existing class: ${selector}`)
        }
      }
    },
    onSkip() {
      const timeElapsed = (Date.now() - this.initialTimestamp) / 1000;
      this.$customizerDataLayer.logAnalyticsEvent({
        type: this.$customizerDataLayer.types.customizerSplashPage,
        eventLabel: `Skip to Get Started - ${timeElapsed.toFixed(2)} sec`,
        forceEcomDataLayerFormat: true
      });
      this.closeClick();
    },
    showComponentsHelpers() {
      this.toggleSplashPageOpenClass();
    },
    verifyModuleVisibility(module) {
      const general_splash_page = this.configuration.splash_page
        .models_properties;
      const pdm_model = this.$store.state.utils.pdmModel;
      const model_splash_page =
        general_splash_page[pdm_model] || general_splash_page["default"];
      return model_splash_page[module];
    },
  },
  mounted() {
    this.initialTimestamp = Date.now();
  },
};
</script>